import config from "@conf";
import { getTenantBaseConfig } from "@/domainMapping/index";

import { isPureWeChat, isWxWork } from "@/utils/device";
import { throttle } from "@/utils/func";
import { Toast } from "vant";
import router from "@/router";

export const getRedirectUrl = (clientId) => {
  const { host, origin, pathname, hash } = window.location;
  if (host.startsWith("localhost") || host.startsWith("192.168")) {
    throw new Error("本地域名无法授权");
  }

  if (hash.slice(1) === "/auth") {
    throw new Error("当前页面已授权，请勿重复授权");
  }
  const baseUrl = origin + pathname;
  const currentPath = hash.slice(1);
  return encodeURIComponent(
    `${baseUrl}#/auth?redirect=${currentPath}&clientId=${clientId}`
  );
};

const redirect = (href) => {
  if (!href) return;
  console.error("Redirecting to:", href);
  window.location.href = href;
};

// 企微环境
export const onWorkWechatAuth = () => {
  try {
    const { appid, agentid, clientid } = getTenantBaseConfig();
    const redirectUrl = getRedirectUrl(clientid);
    const oauthWorkUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_privateinfo&agentid=${agentid}#wechat_redirect`;
    window.location.href = oauthWorkUrl;
  } catch (error) {
    console.error(`[ REQ TOKEN ] Error during Wxwork Auth: ${error}`);
  }
};

// 微信环境
export const onWechatAuth = () => {
  try {
    const { wechatAppid, wechatClinetid, etoDomain, etoAppid } = getTenantBaseConfig();
    const redirectUrl = getRedirectUrl(wechatClinetid);
    // const oauthWorkUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wechatAppid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    const oauthWorkUrl = `${etoDomain}/api/oauth2-authorize?appid=${etoAppid}&scope=snsapi_userinfo&redirect_uri=${redirectUrl}`;
    redirect(oauthWorkUrl);
  } catch (error) {
    console.error(`[ REQ TOKEN ] Error during Wechat Auth: ${error}`);
  }
};

// 统一处理鉴权
export const onNeedAuth = throttle(() => {
  if (
    // 正在模拟微信浏览器
    config.isDevelopAsInWeChat ||
    config.isDevelopAsInWxWork
  ) {
    console.log("[ REQ TOKEN ] 模拟环境不进行自动授权");
    return;
  }

  const hash = window.location.hash;
  if (hash && hash.startsWith("#/auth")) {
    console.log("[ REQ TOKEN ] auth-page-need-auth");
    return;
  }

  localStorage.clear();
  if (isWxWork) {
    onWorkWechatAuth();
  } else if (isPureWeChat) {
    onWechatAuth();
  } else {
    Toast("请在微信环境打开");
  }
}, 100);

export const onNeedJumpAuthTipPage = () => {
  const { hash } = location
  router.replace({
    name: 'AuthPrompt',
    query: {
      redirect: hash.slice(1)
    }
  })
};
